import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';

export function deleteVehicleGroup(vehicleGroupId: number) {
  return fromFetch(
    new Request(`${fleetEnvironment.vehicleGroupsUrl}/${vehicleGroupId}`, {
      method: 'DELETE',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
    })
  ).pipe(ignoreData());
}
